export const appConstants = {
  parentURL: process.env.REACT_APP_CLIENT_PORTAL_URL || '',
};
